import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {builderLicenseActions} from "./builderLicenseSlice";
import {builderLicenseApi} from "../../api";

function* fetchList(action) {
	try {
		const response = yield call(builderLicenseApi.get, action.payload);
		yield put(builderLicenseActions.fetchDataSuccess(response));
	}
	catch (error) {
		let message = error.message;
		if (error?.response?.data?.message) message = error.response.data.message;
		yield put(builderLicenseActions.fetchDataFailed(message));
	}
}

function* handleSearchDebounce(action) {
	yield put(builderLicenseActions.setFilter(action.payload));
}

export default function* builderLicenseSaga() {
	yield takeLatest(builderLicenseActions.fetchData.type, fetchList);
	yield debounce(500, builderLicenseActions.setFilterWithDebounce.type, handleSearchDebounce);
}

